import { GetContactListRequestParams } from '../types/requests/contacts'

export const QUERY_KEYS = {
  apiStatus: ['apiStatus'],
  contacts: ['contacts'],
  contactDetails: (contactId: number) => [QUERY_KEYS.contacts, { contactId }],
  contactList: (params?: GetContactListRequestParams) =>
    params ? [QUERY_KEYS.contacts, params] : ['contacts'],
  currentSession: ['current-session'],
  resetPasswordRequest: (resetPasswordRequestToken: string) =>
    resetPasswordRequestToken
      ? [
          'reset-password-request',
          { resetPasswordRequestId: resetPasswordRequestToken },
        ]
      : ['reset-password-request'],
  sessionList: () => ['sessions'],
  currentSubscription: () => ['current-subscription'],
  tagDetails: (tagId: number) => (tagId ? ['tags', { tagId }] : ['tags']),
  tagList: () => ['tags'],
}
